// 🚨 **TODO.md U-122. Read the modal's state BEFORE hiding it — structurally, not by remembering.**
//
// `#mainModal` has no `fade`, so `mainModal.hide()` fires `hidden.bs.modal` **synchronously**, and
// `packs/application.js`'s handler replaces the modal's entire HTML with an empty shell. Anything read
// after the hide therefore reads an empty document: a selector matches nothing, `.is(':checked')` is
// `false`, `.data(...)` is `undefined`. Nothing throws.
//
// 🔑 **Three sites carried that warning, and all three were written AFTER the bug — two of them shipped:**
//   * the customers download modal (2026-10-30) — `/simplify` moved a flag test after the hide, so both
//     flag lists silently fell through and downloaded notes. The owner found it; no spec drives it.
//   * the dirty-nav Continue button — clearing `navTarget` in `hidden.bs.modal` ran before the handler
//     could read it, and **all three Continue paths stopped working**. The full suite caught it; the
//     branch's own targeted runs did not.
//   * the own-booking confirmation would have been the third: a `false` read there forces every new
//     customer's flag to *no*, which is a wrong value rather than a dead button.
//
// 📌 This is the shape `src/dirtyNav.js` and `src/deleteRecord.js` already exist for in this repo, and
// what `CLAUDE.md` asks for in general: prefer a mechanism correct BY CONSTRUCTION over one kept correct
// by a comment. `spec/config/main_modal_read_order_spec.rb` refuses a hide-then-read in one handler.
//
// ⚠️ **It deliberately does NOT hide on your behalf when you pass no reader** — a caller that wants a
// plain `mainModal.hide()` should write one. This exists for the read-then-hide pair only.
export default function closeMainModalWith(read) {
  const value = read($('#mainModal'))
  mainModal.hide()
  return value
}
